import { Check, Minus } from "lucide-react";
import { Reveal, SectionLabel } from "./shared";
import { useLang } from "./i18n";

export function Comparison() {
  const { t } = useLang();
  return (
    <section className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <SectionLabel>{t.comparison.label}</SectionLabel>
          <h2 className="font-display text-4xl font-semibold leading-[1.1] tracking-[-0.02em] text-ink md:text-5xl">
            {t.comparison.titleA} <span className="italic text-aqua-700">{t.comparison.titleB}</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div data-testid="comparison-table" className="mt-14 overflow-hidden rounded-3xl border border-slate-200 shadow-[0_20px_60px_rgba(15,27,45,0.06)]">
            <div className="grid grid-cols-[1.3fr_1fr_1fr] items-stretch">
              <div className="bg-white p-5" />
              <div className="flex items-center justify-center bg-navy p-5">
                <span className="font-sans text-xl font-extrabold tracking-tight text-white">
                  Settld<span className="text-aqua-400">.</span>
                </span>
              </div>
              <div className="flex items-center justify-center bg-slate-100 p-5">
                <span className="text-sm font-bold uppercase tracking-[0.15em] text-slate-500">{t.comparison.tradHeader}</span>
              </div>
            </div>
            {t.comparison.rows.map((row, i) => (
              <div
                key={i}
                data-testid={`comparison-row-${i}`}
                className={`grid grid-cols-[1.3fr_1fr_1fr] items-stretch border-t border-slate-100 ${i % 2 ? "bg-slate-50/50" : "bg-white"}`}
              >
                <div className="flex items-center p-5 text-sm font-semibold text-ink">{row.label}</div>
                <div className="flex items-center gap-2.5 border-l border-aqua-600/10 bg-aqua-600/[0.05] p-5">
                  <Check size={15} strokeWidth={3} className="shrink-0 text-aqua-600" />
                  <span className="text-sm font-semibold text-navy">{row.settld}</span>
                </div>
                <div className="flex items-center gap-2.5 border-l border-slate-100 p-5">
                  <Minus size={15} className="shrink-0 text-slate-300" />
                  <span className="text-sm text-slate-400">{row.trad}</span>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
